import importedPatientData from './patient_data_john.json';

/** format of the json imput file  */
export interface SleepData {
  day: number;
  total_minutes_sleep: number;
  date: Date;
  value: number;
}

export interface StepsData {
  day: number;
  steps: number;
  date: Date;
  value: number;
}

export interface WakesData {
  day: number;
  total_wakes_episodes: number;
  date: Date;
  value: number;
}

export interface Phq9Data {
  date_str: string;
  values: { question: number; value: number }[];
  date: Date;
  value: number;
}

export interface PatientData {
  sleep: {
    period: SleepData[];
    period_average: number;
    previous_period_average: number;
  };
  steps: {
    period: StepsData[];
    period_average: number;
    previous_period_average: number;
  };
  total_wakes_episodes: {
    period: WakesData[];
    period_average: number;
    previous_period_average: number;
  };
  phq9: {
    period: Phq9Data[];
    questions: Record<number, { day: Date; value: number }[]>;
    period_average: number;
  };
}

/** the patient data */
const patientData: PatientData = (() => {
  const today = new Date(); // Get today's date

  // Deep clone importedPatientData
  const clonedData: PatientData = JSON.parse(JSON.stringify(importedPatientData)) as PatientData;

  // for each sleep data, compute the date from today minus d days
  clonedData.sleep.period.forEach((data) => {
    data.date = new Date(today);
    data.date.setDate(today.getDate() - data.day);
    data.value = data.total_minutes_sleep;
  });
  clonedData.sleep.period.sort((a, b) => a.date.getTime() - b.date.getTime());

  // same for steps data
  clonedData.steps.period.forEach((data) => {
    data.date = new Date(today);
    data.date.setDate(today.getDate() - data.day);
    data.value = data.steps;
  });
  clonedData.steps.period.sort((a, b) => a.date.getTime() - b.date.getTime());

  // same for wakes data
  clonedData.total_wakes_episodes.period.forEach((data) => {
    data.date = new Date(today);
    data.date.setDate(today.getDate() - data.day);
    data.value = data.total_wakes_episodes;
  });
  clonedData.total_wakes_episodes.period.sort((a, b) => a.date.getTime() - b.date.getTime());

  // for each phq9 data, compute the date from today minus 7 days
  clonedData.phq9.period.forEach((data, index) => {
    data.date = new Date(today);
    data.date.setDate(today.getDate() - 7 * index);
    // value is the sum of all the values
    data.value = data.values.reduce((acc, val) => acc + val.value, 0);
  });

  // sort phq9Data by date ascending
  clonedData.phq9.period.sort((a, b) => a.date.getTime() - b.date.getTime());

  // split by questions the phq9 data
  clonedData.phq9.questions = {};
  clonedData.phq9.period.forEach((data) => {
    data.values.forEach((val) => {
      if (!clonedData.phq9.questions[val.question]) {
        clonedData.phq9.questions[val.question] = [];
      }
      clonedData.phq9.questions[val.question].push({ day: data.date, value: val.value });
    });
  });

  // compute the average of the phq9 score for the period
  clonedData.phq9.period_average = clonedData.phq9.period.reduce((acc, val) => acc + val.value, 0) / clonedData.phq9.period.length;

  return clonedData;
})();

export { patientData };
